// Partner-signup page: a marketing-side onboarding form for owners
// (municipalities, port authorities, etc.) who want to list their power
// points on the platform. v1 just records the submission to console + shows
// a thank-you message; backend wiring (POST to an applications
// endpoint with email notification to NRG) lands in a follow-up.
import './site';
import { loadConfig } from '../envConfig';

void loadConfig();

const form = document.querySelector<HTMLFormElement>('#aanmeldformulier form');
form?.addEventListener('submit', (event) => {
  event.preventDefault();

  const data = Object.fromEntries(new FormData(form).entries());
  console.info('[partner-signup] application submitted', data);

  // Simple inline acknowledgement until backend endpoint exists.
  const ack = document.createElement('div');
  ack.className = 'success-box';
  ack.textContent = 'Thanks - we\'ve received your application and will be in touch within two business days.';
  form.replaceWith(ack);
  ack.scrollIntoView({ behavior: 'smooth', block: 'center' });
});
